var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShoppingCart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.667 14.167a1.667 1.667 0 1 1-.001 3.334 1.667 1.667 0 0 1 0-3.334m6.668 0a1.667 1.667 0 1 1-.002 3.333 1.667 1.667 0 0 1 .002-3.333"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.65 2.446a.9.9 0 0 1 .719.651l.512 1.88 12.012.792a.9.9 0 0 1 .841.898v5c0 .47-.363.86-.83.897l-10.835.834a.9.9 0 0 1-.936-.66l-2.32-8.504h-.98a.901.901 0 0 1 0-1.8h1.668zm4.057 4.835a.901.901 0 0 0-1.746.438l.833 3.333a.9.9 0 0 0 1.746-.437zm2.75-.463a.9.9 0 0 0-.764 1.018l.416 2.917a.9.9 0 0 0 1.782-.255l-.417-2.916a.9.9 0 0 0-1.017-.764m3.877.198a.9.9 0 0 0-.9.9v2.5a.9.9 0 0 0 1.8 0v-2.5a.9.9 0 0 0-.9-.9",
  clipRule: "evenodd"
})));
SvgShoppingCart.displayName = "SvgShoppingCart";
export { SvgShoppingCart as ReactComponent };
export default SvgShoppingCart;